// extracted by mini-css-extract-plugin
var _1 = "webpack-pages-DataExtraction-QualityAssessmentTemplate-QualityAssessmentTemplate-module__QualityAssessmentTemplate";
export { _1 as "QualityAssessmentTemplate" }
